import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../service/AuthService';
import moment from 'moment';

const useAutoLogout = () => {

    const navigate = useNavigate();

    useEffect(() => {
        const TAB_ID = crypto.randomUUID();
        const TABS_KEY = "activeTabs";
        const INACTIVITY_TIMEOUT_MINUTES = 10;
        const INACTIVITY_KEY = "lastActivityTimestamp";

        /*
        const registerTab = () => {
            //alert('registerTab');
            const tabs = new Set(JSON.parse(localStorage.getItem(TABS_KEY) || "[]"));
            tabs.add(TAB_ID);
            localStorage.setItem(TABS_KEY, JSON.stringify([...tabs]));
        };

        const unregisterTab = (logout = false) => {
            const tabs = new Set(JSON.parse(localStorage.getItem(TABS_KEY) || "[]"));
            console.log('@@@-unregisterTab-tabs', tabs.size)            
            tabs.delete(TAB_ID);
            if (tabs.size === 0 && logout) {
                //alert('useAutoLogout-unregisterTab-logout'); 
                AuthService.logout(true, false, navigate);
            }
            localStorage.setItem(TABS_KEY, JSON.stringify([...tabs]));
        };
        */

        const updateActivity = () => {
            localStorage.setItem(INACTIVITY_KEY, Date.now().toString());
            localStorage.setItem(INACTIVITY_KEY + '_TEXT', moment().format('YYYY-MM-DD HH:mm:ss'));
        };

        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                updateActivity();
            }
        };

        const startInactivityWatcher = () => {
            const interval = setInterval(() => {
                const raw = localStorage.getItem(INACTIVITY_KEY);
                const last = Number(raw);

                if (!Number.isFinite(last) || last <= 0) {
                    updateActivity();
                    return;
                }

                // Zabezpieczenie na skoki zegara (negatywna różnica)
                let diffMinutes = (Date.now() - last) / 1000 / 60;
                if (diffMinutes < 0) diffMinutes = 0;

                if (diffMinutes > INACTIVITY_TIMEOUT_MINUTES) {
                    //alert('useAutoLogout-startInactivityWatcher-logout: ' + diffMinutes + '\n' + localStorage.getItem(INACTIVITY_KEY + '_TEXT'));
                    localStorage.removeItem(INACTIVITY_KEY);
                    AuthService.logout(true, false, navigate);
                }
            }, 30_000);
            return () => clearInterval(interval);
        };

        const onStorage = (event) => {
            if (event.key === TABS_KEY && event.newValue === "[]") {
                 //AuthService.logout(); // opcjonalnie
            } else if (event.key === 'auth' && (event.newValue === null || event.newValue === 'false')) {
                console.log('useAutoLogout-onStorage-logout');
                navigate('/auth/login?force=true');
            } 
        };

        ["click", "keydown", "mousemove", "scroll", "touchstart"].forEach(event =>
            window.addEventListener(event, updateActivity, { passive: true })
        );
        window.addEventListener("visibilitychange", onVisibilityChange, { passive: true });
        window.addEventListener("focus", updateActivity, { passive: true });
        
        window.addEventListener("storage", onStorage);
        //window.addEventListener("beforeunload", unregisterTab);

        //registerTab();
        updateActivity();
        const stopWatcher = startInactivityWatcher();

        return () => {
            ["click", "keydown", "mousemove", "scroll", "touchstart"].forEach(event =>
                window.removeEventListener(event, updateActivity)
            );           

            window.removeEventListener("storage", onStorage);
            window.removeEventListener("visibilitychange", onVisibilityChange);
            window.removeEventListener("focus", updateActivity);
            //window.removeEventListener("beforeunload", unregisterTab);
            //unregisterTab(false);
            stopWatcher();
        };
    }, []);
}

export default useAutoLogout;